import React from "react";

const CARDS = [
  { key: "dueToday", label: "Due Today", icon: "fa-calendar-day", tone: "info" },
  { key: "dueThisWeek", label: "Due This Week", icon: "fa-calendar-week", tone: "success" },
  { key: "overdue", label: "Overdue", icon: "fa-exclamation-triangle", tone: "warning" },
  { key: "noNextContact", label: "No Next Contact", icon: "fa-user-clock", tone: "muted" },
];

function SRActionCards({ counts, loading, error, onCardClick }) {
  if (error) {
    return (
      <div className="dashboard-error">
        <i className="fas fa-exclamation-circle" /> {error}
      </div>
    );
  }

  return (
    <div className="sr-action-cards">
      {CARDS.map((c) => (
        <button
          type="button"
          key={c.key}
          className={`sr-action-card sr-tone-${c.tone}`}
          onClick={() => onCardClick(c.key)}
          disabled={loading}
        >
          <div className="sr-action-card-icon">
            <i className={`fas ${c.icon}`} />
          </div>
          <div className="sr-action-card-value">
            {loading ? "…" : Number(counts?.[c.key] || 0)}
          </div>
          <div className="sr-action-card-label">{c.label}</div>
          <i className="fas fa-arrow-right sr-action-card-arrow" />
        </button>
      ))}
    </div>
  );
}

export default SRActionCards;